import { classNames } from "../../helpers/classNames";
import Image from "../../components/elements/Image";

const Indentification = ({
  image,
  initial,
  className,
  divStyle,
  initialClass,
  initialStyle,
  defaultClass,
  defaultStyle,
  fill = true,
  alt,
  size = "lg",
  style,
}) => {
  const imageSize = {
    xs: "w-6 h-6",
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
    max: "w-full h-full",
  };

  const src = image;
  const ext = src?.split(".").pop()?.toLowerCase();
  const isVideo = ["mp4", "webm"].includes(ext);

  return (
    <div
      className={classNames(
        "overflow-hidden border rounded-full flex items-center justify-center flex-shrink-0",
        imageSize[size],
        initial ? "text-sm" : "",
        className
      )}
      style={divStyle}
    >
      {image ? (
        isVideo ? (
          <video
            className={classNames(
              "w-full h-full",
              fill ? "object-cover" : "object-contain"
            )}
            src={image}
            alt={alt || initial || image}
            controls
          />
        ) : (
          <Image
            src={image}
            alt={alt || initial || image}
            classes={classNames(
              "w-full h-full",
              fill ? "object-cover" : "object-contain"
            )}
            showErrorImage
          />
        )
      ) : initial ? (
        <div
          className={classNames(
            `w-full h-full flex items-center justify-center font-semibold uppercase text-xs ${initialStyle?.background ? "" : "bg-md-pink-light-2"
            } text-md-pink border border-md-pink/20 !leading-none rounded-full`,
            initialClass
          )}
          style={initialStyle}
        >
          <span className="-mt-[2px]">{initial}</span>
        </div>
      ) : (
        <div
          className={classNames(
            "w-full h-full flex items-center justify-center bg-md-pink-light-2 text-md-pink border border-md-pink/20 rounded-full",
            defaultClass
          )}
          style={defaultStyle}
        >
          <i className="fa-regular fa-fw fa-user"></i>
        </div>
      )}
    </div>
  );
};

export default Indentification;
